import type { FaireProductEntity } from "../../entity_types/product";

export const p_nsqc4dmeqc: FaireProductEntity = {
  token: "p_nsqc4dmeqc",
  type: "product",
  name: "Organic Holy Halvah GoldBar (original)",
  brandToken: "b_psp4uwy7qx",
  brandName: "Holy Halvah",
  imageUrl:
    "https://cdn.faire.com/fastly/84feee73a63ac8fe478e0a1fbb3024a07c9887862fa04f6ac00248cdd927db7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c486500ae40ae364240018c9a1eb037a7e0a3f9faaeff3f0bc09b3b60bd1215.jpeg",
    "https://cdn.faire.com/fastly/5c310e49843912621ca1f84850fa1737cdb4a8c9fbd5d1dcbeab599cc50fde25.jpeg",
    "https://cdn.faire.com/fastly/020eaffcd9dcde3a5b010eda4df59b96394e13cd40c70da6c13c466d23fa2512.jpeg",
    "https://cdn.faire.com/fastly/2c7437fbd39b6def05777fbbdc6c1e253b160e13d476e9a0e1dbdbaeb858a415.jpeg",
    "https://cdn.faire.com/fastly/6228916d016b8a6f9410dac8173219b194724eb5dbb52128f5c1eb8f65d76ca2.png",
  ],
  priceDollars: 6.24,
  description:
    "Halvah is a simple, traditional sesame based snack. Our recipe uses just four real food ingredients: Organic sesame tahini, pure Vermont maple syrup, vanilla, and sea salt. That's it! This beautifully simple treat is an amazing energy source, and is free of gluten, grains, dairy, and refined sugar. \n\nOur GoldBar (original) is created with organic sesame tahini made from hulled, lightly roasted white sesame seeds. It is sweetened with Vermont maple syrup and is characterized by its sweeter and stronger flavor. Packaged in gold mylar bags to compliment their natural color and showcase their appeal as high quality, specialty goods.\n\nHoly Halvah is a super premium, organic, small batch, real food product\nWe choose to create this halvah without the use of additives or emulsifiers, and  it can be stored on the shelf for two weeks in a climate controlled environment (below 70F). Store for two months in a cooler, and up to a year in a freezer.\n\n\n",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:58.904Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
